/**
 * Ошибка в текст для пользователя.
 *
 * Вынесено из SettingsView, когда понадобилось второму экрану. Дублировать
 * такую функцию нельзя: она содержит решение о том, что показывать при 403, а
 * две копии этого решения разойдутся — и разойдутся именно в том месте, где
 * ошибка означает отказ в доступе.
 */

import { ApiError } from "./api.js";

export function describeError(error: unknown): string {
  if (error instanceof ApiError) {
    // 403 намеренно без деталей — сервер их не отдаёт, и придумывать нечего.
    return error.isForbidden
      ? "Недостаточно прав для этого действия"
      : error.message;
  }
  return error instanceof Error ? error.message : "Неизвестная ошибка";
}
